import React from 'react'
import {hhApi} from "../../../api/hh-api";
import {toast} from "react-toastify";
import {useStores} from "../../../stores";

type Props = {
  vacancyIdUKI: any
  legacy_id: string
  update: () => void
}

const AddVacancy = (props: Props) => {
  const { authStore } = useStores();
  const vacancyCompanyId = authStore.user?.vacancyCompany || null
  const handleFetch = async () => {
    const loadingToastId = toast.loading("Загрузка откликов началась...");
    try {
      const res = await hhApi.getVacancyResponses(props.legacy_id, props.vacancyIdUKI, vacancyCompanyId);

      toast.update(loadingToastId, {
        render: "Загрузка завершена успешно!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      props.update()
    } catch (error: any) {
      const isAxiosTimeout =
        error.code === 'ECONNABORTED' ||
        error.message?.includes('timeout');

      const isGatewayTimeout =
        error.code === 'ERR_NETWORK' && error?.request?.status === 0;

      if (isAxiosTimeout || isGatewayTimeout) {
        toast.update(loadingToastId, {
          render: "Превышено время ожидания. Загрузка может продолжаться в фоновом режиме.",
          type: "warning",
          isLoading: false,
          autoClose: 5000,
        });
      } else {
        const code = error?.response?.status || 'неизвестно';
        toast.update(loadingToastId, {
          render: `Ошибка при загрузке откликов! (Код: ${code})`,
          type: "error",
          isLoading: false,
          autoClose: 5000,
        });
      }
    }
  }



  return <>
    <a href="/" className='dropdown-item' onClick={(e) => {
      e.preventDefault()
      handleFetch()
    }}>
      Загрузить кандидатов из HH
    </a>

  </>
}

export default AddVacancy